<template>
	<div class="container__menucarduser">
		<div class="container__menucarduser__foto">
			<div class="container__menucarduser__foto__profile">
				<!-- <img src="https://www.kindpng.com/picc/m/24-248253_user-profile-default-image-png-clipart-png-download.png" /> -->
				<img
					:src="fotoUrl"
					@error="onImageError"
				/>
			</div>
			<router-link
				class="hover:underline"
				:to="{ path: '/usuarios', query: { email: email } }"
			>
				Editar perfil
			</router-link>
			<!-- <div class="container__menucarduser__foto__changefoto">
        <i class="fas fa-camera-retro"></i>
      </div> -->
		</div>
		<div class="container__menucarduser__info">
			<label class="container__menucarduser__info__organizarion">{{ emailFormatado }}</label>

			<label class="container__menucarduser__info__user">SmartForest - Agility</label>

			<!-- <div class="choose_lenguage_container">
        <i
          @click="setLocation('ptbr')"
          class="br flag"
        ></i>
        <i
          @click="setLocation('en')"
          class="us flag"
        ></i>
        <i
          @click="setLocation('es')"
          class="es flag"
        ></i>
      </div> -->

			<div class="container__menucarduser__buttons">
				<Button
					:label="$t('exit')"
					semantic-class="mini"
					color="trv-error"
					outlined
					with-auto
					@click="$router.push('/login')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '../../Button/Button'
import { refreshFotoUrl } from '../../../services/profilePhoto'
export default {
	components: { Button },
	data() {
		return {
			// reativo: inicia do localStorage e é renovado no mounted
			fotoUrlAtual: localStorage.getItem('fotoUrl') || '',
			// quando o SAS da fotoUrl expira (403), cai no avatar de iniciais
			imageFailed: false,
		}
	},
	computed: {
		fotoUrl() {
			if (!this.fotoUrlAtual || this.imageFailed) {
				return `https://ui-avatars.com/api/?name=${this.emailFormatado}`
			}
			return this.fotoUrlAtual
		},
		username() {
			return localStorage.getItem('username')
		},
		emailFormatado() {
			return this.username.split('@')[0]
		},
		email() {
			return localStorage.getItem('email')
		},
	},
	async mounted() {
		// renova o SAS da foto (o gravado no login expira em ~30min)
		const novaFotoUrl = await refreshFotoUrl()
		if (novaFotoUrl !== null) {
			this.fotoUrlAtual = novaFotoUrl
			this.imageFailed = false
		}
	},
	methods: {
		setLocation(locale) {
			this.$i18n.locale = locale
			localStorage.setItem('locale', locale)
		},
		onImageError() {
			this.imageFailed = true
		},
	},
}
</script>

<style scoped>
.container__menucarduser {
	font-size: 0.75rem;
	height: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	background-color: white;
	z-index: 100;
	padding: 1rem 2rem;
	border: 1px solid rgb(var(--color-neutral));
	margin: 0 2rem;
}

.container__menucarduser__foto {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.container__menucarduser__foto__profile {
	height: 6rem;
	width: 6rem;
	border-radius: 50%;
	overflow: hidden;
}

.container__menucarduser__foto__profile img {
	height: 6rem;
	width: 6rem;
}

.container__menucarduser__foto__changefoto {
	background-color: white;
	color: #747474;
	border-radius: 50%;
	padding: 0.4rem;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1rem;
	position: absolute;
	bottom: 0;
	right: 0;
	box-shadow:
		0 1px 1px 0 rgba(65, 69, 73, 0.3),
		0 1px 3px 1px rgba(65, 69, 73, 0.15);
	cursor: pointer;
}

.container__menucarduser__foto__changefoto:hover {
	color: rgb(var(--color-primary));
}

.container__menucarduser__info {
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 100%;
	margin-left: 2rem;
}

.container__menucarduser__info__organizarion {
	font-size: 1rem;
	font-weight: 600;
}

.container__menucarduser__info__user {
	color: rgb(128, 128, 128);
}

.container__menucarduser__buttons {
	display: flex;
	justify-content: space-between;
	margin-top: 0.5rem;
}

.choose_lenguage_container {
	display: flex;
	margin: 0.5rem 0;
}

i {
	cursor: pointer;
}

@media screen and (min-width: 576px) {
	.container__menucarduser {
		margin: 0;
	}
}
</style>
